import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        d: "M9.472.233c.48-.068.997-.069 1.476 0C19.756.54 27.584 6.35 30.356 14.695l-8.115 3.95c3.664 3.195 6.725 7.128 8.848 11.505l-3.241 1.668h-.074c-2.78-5.711-7.304-10.637-12.767-13.874l10.285-5.101.115-.108c-2.375-4.246-6.666-7.363-11.433-8.407-.395-.086-1.964-.417-2.243-.321a.15.15 0 0 0-.105.115L5.192 30.785H.912L8.295.312C8.69.26 9.076.247 9.472.233",
        fill: "#3F7B8B"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("rect", {
          width: "32",
          height: "32",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }